import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getNotifications: {
    method: 'GET',
    url: `${configs.baseUrl}/api/notifications/`,
  },
  getCountNotificationUnread: {
    method: 'GET',
    url: `${configs.baseUrl}/api/notifications/count-unread/`,
  },
  getPopupNotification: {
    method: 'GET',
    url: `${configs.baseUrl}/api/notifications/popup/`,
  },
  readNotification: {
    method: 'POST',
    url: `${configs.baseUrl}/api/notifications/read-notification/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getNotifications = async (query = {}) => {
  const res = await resource.getNotifications(query)

  return res.body
}

const getCountNotificationUnread = async () => {
  const res = await resource.getCountNotificationUnread()
  return res.body
}

const getPopupNotification = async () => {
  const res = await resource.getPopupNotification()
  return res.body
}

const readNotification = async (payload) => {
  const res = await resource.readNotification(payload)
  return res.body
}

export default {
  initResource,
  getNotifications,
  getCountNotificationUnread,
  getPopupNotification,
  readNotification,
}
